import React, { FC } from 'react'
import { isMobile } from 'react-device-detect'

import { Column, Row, Text } from '../../../components'

import { getPriceWithSymbol } from '../helpers'

import { useStyle } from './observe-options-variant.styles'
import { ObserveOptionVariantProps } from './observe-options-variant.types'

export const ObserveOptionVariant: FC<ObserveOptionVariantProps> = ({
  data,
  title,
  titleTx,
  currency
}) => {
  const classes = useStyle()

  const Container = isMobile ? Column : Row

  return (
    <Column
      fullWidth
      className={classes.offersRow}
      justifyContent="space-between"
    >
      <Container fullWidth justifyContent="flex-start" alignItems="flex-start">
        <Row fullWidth className={classes.name} justifyContent="space-between">
          <Text color="inactive" text={title} tx={titleTx} preset="body" />
        </Row>
        <Column fullWidth>
          {data.map((item) => (
            <Column
              fullWidth
              key={`variant_${item.id}`}
              className={classes.value}
              alignItems="flex-start"
            >
              <Row fullWidth justifyContent="space-between">
                <Text text={item.title || '-'} preset="h7" />
                <Row className={classes.textRow} justifyContent="flex-end">
                  <Text
                    className={classes.textDays}
                    text={String(item.extraProductionDays)}
                  />
                  <Text
                    className={classes.textPrice}
                    text={getPriceWithSymbol(item.extraPrice, currency)}
                    preset="body"
                  />
                </Row>
              </Row>
              <Text
                className={classes.textDescription}
                text={item.description || '-'}
                preset="title"
              />
            </Column>
          ))}
        </Column>
      </Container>
    </Column>
  )
}
